<template>
    <div class="row">
        <div class="col-12">
            <div class="badge d-flex align-items-center p-2 text-wrap" :class="type">
                <div class="icon p-0" :class="type">
                    <i class="fa-2x" :class="icon"></i>
                </div>
                <div class="text flex-grow-1">
                    <p v-html="text" class="badge-text mb-0 text-center"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BadgeAlert",
        props: {
            type: {
                type: String,
                required: false,
                default: "success"
            },
            text: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: false,
                default: "fas fa-check-circle"
            }
        }
    }
</script>

<style scoped lang="scss">
    $green: #209431;
    $white: white;

    .badge {
        border-radius: 10rem;
        border: none;
        font-weight: normal;

        &.success {
          background-color: lightgrey;
        }

        .icon {
            &.success {
              color: #801977;
            }
        }

        .badge-text {
          font-size: 1.7em !important;
          color: black;
          overflow-wrap: break-word;
        }
    }
</style>
